module.exports = __webpack_public_path__ + "static/img/prevasa.5949e1a2.png";